export class Toast {
	static async ShowSuccess(title, message, options) {
		return this.#Open("SUCCESS", {
			Title: title,
			Message: message,
			Icon: "far fa-check", ...options
		});
	}

	static async ShowWarning(title, message, options) {
		return this.#Open("WARNING", {
			Title: title,
			Message: message,
			Icon: "far fa-exclamation-triangle", ...options
		});
	}

	static async ShowInfo(title, message, options) {
		return this.#Open("INFO", {
			Title: title,
			Message: message,
			Icon: "far fa-info-circle", ...options
		});
	}

	static async ShowError(title, message, options) {
		return this.#Open("ERROR", {
			Title: title,
			Message: message,
			Icon: "far fa-times-octagon", ...options
		});
	}

	static #RenderToast(type, options) {
		let message = options.Message ?? "";

		const toast = document.createElementWithContents("div", `
        <div class="chip-toast toast-${type.toLowerCase()}" role="alert" aria-live="assertive" aria-atomic="true">
					<div class="h-align gap-md">
						<chip-icon
							class="toast--icon"
							size="lg"
							icon="${options.Icon}">
						</chip-icon>
						<div>
							<div class="${message?.trim() ? "toast--title" : ""}">${options.Title}</div>
							<div class="toast--message">${message}</div>
						</div>
						<chip-button description="Close toast" variation="body" button-style="icon" icon="fal fa-times"></chip-button>
					</div>
        </div>`).firstElementChild;

		toast.querySelector("chip-button").onclick = () => this.CloseToast(toast);

		return toast;
	}

	static CloseToast(toast) {
		toast.remove();
	}

	static #Open(type, options) {
		const toast = this.#RenderToast(type, options);
		this.#GetOrCreateContainer()?.appendChild(toast);

		let timeout = setTimeout(() => Toast.CloseToast(toast), 5000);

		toast.onmouseenter = () => clearTimeout(timeout);
		toast.onmouseleave = () => timeout = setTimeout(() => Toast.CloseToast(toast), 5000);

		setTimeout(() => {
			toast.classList.add("show");
		}, 1);
	}

	static #GetOrCreateContainer() {
		const toastContainer = document.querySelector(".toast__wrapper") ?? document.createElementWithContents("div", "", { className: "toast__wrapper" });

		if (toastContainer) {
			document.body.prepend(toastContainer);
		}

		return toastContainer;
	}
}